
import React, { useState, useEffect } from 'react';
import { Coffee } from 'lucide-react';

interface GlobalLoaderProps {
    message?: string;
    delay?: number; // Ms att vänta innan visning
}

export const GlobalLoader: React.FC<GlobalLoaderProps> = ({ 
    message = "Laddar CoffeeNova...", 
    delay = 300 // Standard 300ms delay för att undvika "blinkande"
}) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShow(true);
        }, delay);

        return () => clearTimeout(timer);
    }, [delay]);

    if (!show) return null; // Rendera ingenting innan tiden gått ut

    return (
        <div className="min-h-screen bg-coffee-50 flex flex-col items-center justify-center gap-6 animate-fade-in pt-12">
            <div className="relative">
                <div className="absolute inset-0 bg-coffee-200 rounded-full blur-2xl opacity-20 animate-pulse"></div>
                <div className="bg-white p-6 rounded-3xl shadow-xl border border-coffee-100 relative">
                    <Coffee className="text-coffee-600 animate-bounce" size={48} />
                </div>
            </div>
            <div className="text-center space-y-2">
                <p className="text-coffee-900 font-black uppercase tracking-widest text-sm">{message}</p>
                <div className="flex gap-1 justify-center">
                    <div className="w-1.5 h-1.5 bg-coffee-400 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
                    <div className="w-1.5 h-1.5 bg-coffee-400 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
                    <div className="w-1.5 h-1.5 bg-coffee-400 rounded-full animate-bounce"></div>
                </div>
            </div>
        </div>
    );
};
